/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Toggle_Markers_TitleInputs */

const en_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show/Hide Markers`)
};

const fr_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher/Masquer les marqueurs`)
};

const de_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markierungen ein-/ausblenden`)
};

const it_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra/Nascondi marcatori`)
};

const ru_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать/скрыть маркеры`)
};

const es_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar/ocultar marcadores`)
};

const zh_cn2_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示/隐藏标记`)
};

const ja_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーの表示/非表示`)
};

const hi_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर दिखाएँ/छिपाएँ`)
};

const pt_pt2_timeline_toggle_markers_title = /** @type {(inputs: Timeline_Toggle_Markers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar/Ocultar Marcadores`)
};

/**
* | output |
* | --- |
* | "Show/Hide Markers" |
*
* @param {Timeline_Toggle_Markers_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_toggle_markers_title = /** @type {((inputs?: Timeline_Toggle_Markers_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Toggle_Markers_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_toggle_markers_title(inputs)
	if (locale === "de") return de_timeline_toggle_markers_title(inputs)
	if (locale === "it") return it_timeline_toggle_markers_title(inputs)
	if (locale === "ru") return ru_timeline_toggle_markers_title(inputs)
	if (locale === "es") return es_timeline_toggle_markers_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_toggle_markers_title(inputs)
	if (locale === "ja") return ja_timeline_toggle_markers_title(inputs)
	if (locale === "hi") return hi_timeline_toggle_markers_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_toggle_markers_title(inputs)
	return en_timeline_toggle_markers_title(inputs)
});